import csTools from 'cornerstone-tools';
import scroll from './scroll.js';

const BaseTool = csTools.importInternal('base/BaseTool');

/**
 * @public
 * @class StackScrollMouseWheelTool
 * @memberof Tools
 *
 * @classdesc Tool for scrolling through a series using the mouse wheel.
 * @extends Tools.Base.BaseTool
 */
export default class MoveFrameTool extends BaseTool {
  constructor(props = {}) {
    const defaultProps = {
      name: 'MoveFrame',
      supportedInteractionTypes: [''],
      configuration: {},
    };

    super(props, defaultProps);
  }

  clickCallbackForward = (element) => {
    // element, direction, loop, allowSkipping
    scroll(element, 1, false, false);
  };

  clickCallbackBackward = (element) => {
    // element, direction, loop, allowSkipping
    scroll(element, -1, false, false);
  };
}
